import {isAdminURL, isInternalURL} from './url'

/**
 * Maybe override URL of back buttons
 */
function overrideBackButtonsURL()
{
  const backButtons = document.querySelectorAll('.go-back')

  // No back buttons found
  if ( backButtons.length === 0 )
  {
    return
  }

  // Get referrer
  const referrer = document.referrer

  // Change URL of the back button if referrer is set, it's an internal URL and it's not an admin URL.
  if ( referrer && true === isInternalURL(referrer) && false === isAdminURL(referrer) )
  {
    for ( const backButton of backButtons )
    {
      if ( backButton.href !== referrer )
      {
        backButton.href = referrer
      }
    }
  }
}

/**
 * Listen for DOMContentLoaded event
 */
document.addEventListener('DOMContentLoaded', function() {
  // Maybe override URL of back buttons
  overrideBackButtonsURL()
})